module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地理位置"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.regions
    },
    on: {
      "change": _vm.handleRegionChange
    },
    model: {
      value: (_vm.form.regions_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "regions_id", $$v)
      },
      expression: "form.regions_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    attrs: {
      "id": "keyword",
      "placeholder": "请输入具体地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword()
      }
    }
  }, [_vm._v("搜索定位")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地图定位"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    attrs: {
      "id": "qqmap_rslist"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    attrs: {
      "id": "qqmap_container"
    }
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": "true",
      "label": "社区经纬度"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "经度"
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.$set(_vm.form, "lng", $$v)
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "纬度"
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.$set(_vm.form, "lat", $$v)
      },
      expression: "form.lat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": "true",
      "label": "社区详细地址"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "id": "keyword",
      "placeholder": "请输入具体提货地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "社区名称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.community_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "community_name", $$v)
      },
      expression: "form.community_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团长姓名"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.leader_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "leader_name", $$v)
      },
      expression: "form.leader_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团长手机"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.leader_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "leader_mobile", $$v)
      },
      expression: "form.leader_mobile"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团长身份证"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.leader_id_card),
      callback: function($$v) {
        _vm.$set(_vm.form, "leader_id_card", $$v)
      },
      expression: "form.leader_id_card"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团长昵称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.leader_nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "leader_nickname", $$v)
      },
      expression: "form.leader_nickname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注说明"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.referrer),
      callback: function($$v) {
        _vm.$set(_vm.form, "referrer", $$v)
      },
      expression: "form.referrer"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BD"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.bd),
      callback: function($$v) {
        _vm.$set(_vm.form, "bd", $$v)
      },
      expression: "form.bd"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "社区人数"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.num),
      callback: function($$v) {
        _vm.$set(_vm.form, "num", $$v)
      },
      expression: "form.num"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小区商圈"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.business_district),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_district", $$v)
      },
      expression: "form.business_district"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qqmap_infowin_flag),
      expression: "qqmap_infowin_flag"
    }],
    attrs: {
      "id": "qqmap_infowin"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.imp_poi(_vm.poi_info)
      }
    }
  }, [_vm._v("导入社区地址信息")])], 1), _vm._v(" "), _c('el-col', [_vm._v(_vm._s(_vm.poi_info.address))])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2226004e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2226004e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/add.vue
// module id = 2533
// module chunks = 0